import { formatDate } from '../../../../helpers/date'
import { PayrollPeriod } from '../../../entities/PayrollPeriod/PayrollPeriod'
import { getPayrollPeriodEndDateLabel } from '../../../entities/PayrollPeriod/PayrollPeriodHelpers'
import trans from '../../../helpers/trans'
import { SelectOption } from '../../../types'

export const generateNumberSelectOptions = (
    periods: PayrollPeriod[],
    hasPeriodTitle = false,
    rangeIncludesLastDay = true,
    enableAllPeriodsExport = false,
): SelectOption[] => {
    const options: SelectOption[] = []

    if (enableAllPeriodsExport) options.push({ value: 'all-periods', label: trans('compositions.selectPayrollPeriod.allPeriods') })

    periods.forEach(payrollPeriod => {
        const title = hasPeriodTitle ? (
            `${trans('common.period')} ${payrollPeriod.periodNumber}:`
        ) : (payrollPeriod.periodNumber)

        const rangeSeparator = rangeIncludesLastDay ? trans('common.until') : '-'

        options.push({
            value: payrollPeriod.id,
            label: `${title} (${formatDate(payrollPeriod.period.start, 'd MMMM')} ${rangeSeparator} ${getPayrollPeriodEndDateLabel(payrollPeriod, 'd MMMM')})`,
        })
    })

    return options
}

export const generateYearSelectOptions = (years: number[]): SelectOption[] => years.map(year => ({
    value: year.toString(),
    label: year.toString(),
}))
